import { fetch } from '../utils/request';

const BaseUrl = process.env.MONO_BASE;
const getUrl = (path) => `${BaseUrl}${path}`;

export default {
  getSnippets() {
    return fetch(getUrl('/snippets'));
  },

  getSnippet(id) {
    return fetch(getUrl(`/snippets/${id}`));
  },

  createSnippet(snippet) {
    return fetch(getUrl('/snippets'), {
      method: 'POST',
      body: JSON.stringify(snippet),
    });
  },

  editSnippet(id, fields = {}) {
    return fetch(getUrl(`/snippets/${id}`), {
      method: 'PUT',
      body: JSON.stringify(fields),
    });
  },

  deleteSnippet(id) {
    return fetch(getUrl(`/snippets/${id}`), { method: 'DELETE' });
  },

  duplicateSnippet(id) {
    return fetch(getUrl(`/snippets/${id}/duplicate`), { method: 'POST' });
  },
};
